var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLudoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178.29 187.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#695af7;}.cls-3{fill:#dc143c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.35,125.7,60.06,179a15.3,15.3,0,0,0,20.73,6.22l89.45-48.17a15.3,15.3,0,0,0,6.22-20.74L147.75,63Zm40.72,18.6a15.32,15.32,0,1,1,20.76,6.22A15.32,15.32,0,0,1,72.07,144.3Zm63.16-16.61a15.33,15.33,0,1,1,6.23-20.76A15.33,15.33,0,0,1,135.23,127.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.87,1.89,8.32,49.58A15.83,15.83,0,0,0,1.89,71l27.55,51.14a1.94,1.94,0,0,0,2.64.8l113-60.83a2,2,0,0,0,.79-2.65L118.3,8.32A15.83,15.83,0,0,0,96.87,1.89Zm7.41,36a15.32,15.32,0,1,1-20.76-6.22A15.32,15.32,0,0,1,104.28,37.89ZM41.12,54.5a15.33,15.33,0,1,1-6.23,20.76A15.33,15.33,0,0,1,41.12,54.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.39,126.57,63.9,175.79a11.63,11.63,0,0,0,15.76,4.73l87.87-47.32a11.64,11.64,0,0,0,4.72-15.76L145.74,68.22Zm55.44,24a15.32,15.32,0,1,1,6.22-20.76A15.32,15.32,0,0,1,92.83,150.52Zm42.4-22.83a15.33,15.33,0,1,1,6.23-20.76A15.33,15.33,0,0,1,135.23,127.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.43,4.9,10.57,52.22A11.64,11.64,0,0,0,5.84,68l26.52,49.23L140.71,58.86,114.19,9.63A11.64,11.64,0,0,0,98.43,4.9ZM55.65,81.49a15.33,15.33,0,1,1,6.23-20.76A15.33,15.33,0,0,1,55.65,81.49ZM98.06,58.65a15.32,15.32,0,1,1,6.22-20.76A15.32,15.32,0,0,1,98.06,58.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudoLogo);
export default __webpack_public_path__ + "static/media/ludo_logo.3a216a8fe1b6ba0aa4bd52421e0df46b.svg";
export { ForwardRef as ReactComponent };